export const PathsToExcludeConstant = ["/chat"];
